export const Profile_Settings_DA = {
  settings: {
    headline: "Indstillinger",
    desc: "Administrer dine kontoindstillinger og vælg dit brugeravatar.",
    tabs: {
      yourInfo: "Dine oplysninger",
      profileImage: "Profilbillede",
      connections: "Forbindelser",
      themes: "Temaer",
      preferences: "Præferencer",
      changePassword: "Skift adgangskode",
      otherSettings: "Andet",
      language: "Sprog",
    },
    password_reset: {
      head: "Opdater din adgangskode",
      steps: {
        1: "Indtast din e-mail adresse for at modtage en 6-cifret kode.",
        2: "Indtast den 6-cifret nulstillingskode.",
        3: "Indtast en nyt adgangskode.",
        4: "Gentag din nye adgangskode.",
      },
    },
    terms:
      "Jeg må gerne blive kontaktet via e-mail, hvis jeg vinder en giveaway, konkurrence eller lignende event.",
    sendResetPasswordCode: "Send nulstillingskode",
  },
};
